import Breadcrumbs from "../../../components/breadcrumbs";
import ShoppingCompanyCreateForm from "./ui/shopping-company-create-form";
import ShoppingCompanySkeleton from "./skeleton/shopping-company-skeleton";
import useShoppingCategories from "../../../hooks/useShoppingCategories";

export default function ShoppingCompanyCreatePage() {
  const { shoppingCategories, loading } = useShoppingCategories();

  return (
    <main className="max-w-3xl">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Shopping Companies", href: "/admin/shopping-companies" },
          {
            label: "Create",
            href: "/admin/shopping-companies/create",
            active: true,
          },
        ]}
      />
      {loading ? (
        <ShoppingCompanySkeleton />
      ) : (
        <ShoppingCompanyCreateForm categories={shoppingCategories} />
      )}
    </main>
  );
}
